<template>
  <b-modal
    id="add-project-thumbnail"
    size="xl"
    centered
    no-close-on-backdrop
    @close="onHideModal"
    title="Add/Edit Project Thumbnail - Brand"
  >
    <form id="add-banner-form" @submit.prevent="submit">
      <div class="flex-row">
        <div class="col-md-12">
          <b-form-group label="Select Project">
            <b-form-select
              class="select"
              v-model="data.project_id"
              :class="{ 'has-error': !validateForm.projectID }"
            >
              <option :value="null" disabled>
                -- Please select project --
              </option>
              <template>
                <option
                  v-for="projectData in projectList"
                  :value="projectData.id"
                  :key="projectData.id"
                >
                  {{ projectData.name.th }}
                </option>
              </template>
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="flex-row col-md-12">
        <div class="thumbnail-picker-wrapper">
          <ImageUploadNew
            :isRequired="false"
            :maxFile="1"
            :uploadSetting="{ ...uploadSetting }"
            :dataImage="{ ...image }"
            :showError="uploadImgError"
            :onFileUploaded="onFileUploadImage"
          />
        </div>
        <div class="flex-1">
          <b-form-group
            style="font-weight: 600"
            label="Thumbnail (500 x 280 pixel)"
          >
            <div class="flex-row">
              <p style="margin-right: 5px; flex: 1 10%" class="alt-thumb">
                ALT Text
              </p>
              <b-form-input
                type="text"
                placeholder="Typing Something..."
                v-model="data.thumbnail.alt"
              ></b-form-input>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="col-md-12">
        <b-tabs content-class="mt-3">
          <b-tab title="ภาษาไทย">
            <b-form-group label="Detail">
              <b-form-textarea
                v-model="data.description.th"
                placeholder="Input Detail"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
          </b-tab>
          <b-tab title="English">
            <b-form-group label="Detail">
              <b-form-textarea
                v-model="data.description.en"
                placeholder="Input Detail"
                rows="3"
                max-rows="6"
              />
            </b-form-group>
          </b-tab>
        </b-tabs>
      </div>
    </form>
    <template slot="modal-footer">
      <b-button size="sm" variant="primary" type="submit" form="add-banner-form"
        >Save</b-button
      >
      <b-button size="sm" variant="danger" @click="onHideModal()"
        >Cancel</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import ImageUploadNew from '../ImageUploadNew'
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'

export default {
  props: {
    thumbnailList: Array,
    categoryID: Number,
    data: Object,
    onSubmitForm: Function,
  },
  components: {
    ImageUploadNew,
  },
  data: () => ({
    projectList: [],
    image: {
      source: '',
      name: '',
    },
    uploadImgError: false,
    validateForm: {
      projectID: true,
    },
    uploadSetting: {
      showPreview: false,
      showDelete: true,
      showAlt: false,
    },
  }),
  methods: {
    ...mapActions({
      getProjectList: ActionFetch.PROJECTS.MAIN.INDEX,
    }),
    onHideModal() {
      this.uploadImgError = false
      this.validateForm = {
        projectID: true,
      }

      this.$bvModal.hide('add-project-thumbnail')
    },
    showProject($project) {
      const project = this.thumbnailList.find(($reg) => {
        return (
          $reg.project_id === $project.id &&
          this.data.project_id !== $project.id
        )
      })

      return !project
    },
    submit($e) {
      $e.preventDefault()

      this.uploadImgError = !this.data.thumbnail.filename
      this.validateForm = {
        projectID: !!this.data.project_id,
      }

      if (this.validateForm.projectID && !this.uploadImgError) {
        this.onSubmitForm(this.data)
        this.$bvModal.hide('add-project-thumbnail')
      }
    },
    fetchProject() {
      const condition = {
        cid: this.categoryID,
        apiVersion: '/v1',
      }
      this.getProjectList(condition).then(($res) => {
        this.projectList = $res.data
      })
    },
    onFileUploadImage($value) {
      this.data.thumbnail.filename = $value.source
    },
  },
  watch: {
    'data.thumbnail': function (value) {
      this.image = {
        source: value.filename,
        name: value.alt,
      }
    },
    categoryID: function (value) {
      this.fetchProject()
    },
  },
  created() {
    this.fetchProject()
  },
}
</script>

<style scoped>
.file-name {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #666666;
  margin-left: 10px;
}
.p-icon {
  min-width: 100px;
}
</style>
